// The #fragment of every URL in any string of a value: on /hosted it can hold the link token (#t=).
const URL_FRAGMENT = /((?:\b[a-z][a-z\d+.-]*:\/\/|\/)[^\s#"'<>]*)#[^\s"'<>]*/gi

const MAX_DEPTH = 16

const isPlainObject = (value: object): boolean => {
  const proto = Object.getPrototypeOf(value)
  return proto === Object.prototype || proto === null
}

export const stripUrlFragments = <T>(value: T, depth = 0): T => {
  if (typeof value === 'string') {
    return value.replace(URL_FRAGMENT, '$1') as T
  }
  // Class instances (Sentry keeps scopes in sdkProcessingMetadata) are left whole.
  if (!value || typeof value !== 'object' || (!Array.isArray(value) && !isPlainObject(value))) {
    return value
  }
  // Fails closed: a subtree past the bound is dropped rather than sent unscrubbed.
  if (depth > MAX_DEPTH) {
    return '[Filtered]' as T
  }
  if (Array.isArray(value)) {
    return value.map((item) => stripUrlFragments(item, depth + 1)) as T
  }
  return Object.fromEntries(
    Object.entries(value).map(([key, nested]) => [key, stripUrlFragments(nested, depth + 1)]),
  ) as T
}
